// extracted by mini-css-extract-plugin
export default {"menuDropdown":"MenuDropdown_menuDropdown__orMEb"};